import { MessageCircle, ArrowUp } from "lucide-react";
import { useEffect, useState } from "react";
import { SITE } from "../lib/site";

export const FloatingActions = () => {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 400);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="fixed right-5 bottom-5 z-40 flex flex-col items-end gap-3">
      {showTop && (
        <button
          data-testid="back-to-top"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          aria-label="Back to top"
          className="w-11 h-11 rounded-md bg-brand-ink text-white flex items-center justify-center shadow-lg hover:bg-brand-orange transition-colors"
        >
          <ArrowUp size={18} />
        </button>
      )}
      <a
        href={SITE.whatsappBase}
        target="_blank"
        rel="noreferrer"
        data-testid="floating-whatsapp"
        aria-label="Chat on WhatsApp"
        className="w-14 h-14 rounded-full bg-brand-green hover:bg-brand-greenDark text-white flex items-center justify-center shadow-xl transition-colors relative"
      >
        <span className="absolute inset-0 rounded-full bg-brand-green animate-ping opacity-30"></span>
        <MessageCircle size={26} className="relative" />
      </a>
    </div>
  );
};
